import React from 'react';
import { Tab, Tabs } from '@mui/material';

type PropTypes = {
  orientation: 'horizontal' | 'vertical';
  value: number;
  tabList: { index: number; label: string }[];
  handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;
};

function a11yProps(index: number) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export const PageTabs = ({
  orientation,
  tabList,
  value,
  handleTabChange,
}: PropTypes) => {
  return (
    <Tabs
      orientation={orientation}
      variant="scrollable"
      value={value}
      onChange={handleTabChange}
      sx={
        orientation === 'horizontal'
          ? { borderBottom: 1, borderColor: 'divider' }
          : {
              borderRight: 1,
              borderColor: 'divider',
              minWidth: '152px',
              maxWidth: '152px',
            }
      }
    >
      {tabList.map((item, i) => (
        <Tab
          key={i}
          label={item.label}
          {...a11yProps(item.index)}
          sx={{
            alignItems: 'flex-start',
            textAlign: 'left',
          }}
        />
      ))}
    </Tabs>
  );
};
